import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20sunset%20light%20over%20a%20serene%20landscape%20with%20gentle%20hills%20and%20a%20winding%20path%2C%20soft%20golden%20and%20amber%20tones%2C%20two%20distant%20figures%20walking%20together%2C%20atmospheric%20and%20hopeful%2C%20abstract%20painterly%20style%2C%20warm%20color%20palette%2C%20no%20text%2C%20ethereal%20mood&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
        alt="人善交 - 结交善良之人，共建美好人际圈"
        className="absolute inset-0 w-full h-full object-cover"
        title="人善交 - 结交善良之人，共建美好人际圈"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight"
          style={{ fontFamily: 'var(--font-heading)' }}>
          人善交
        </h1>
        <p className="text-lg md:text-2xl text-white/90 mb-3 leading-relaxed">
          结交善良之人，共建美好人际圈
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-2xl mx-auto leading-relaxed">
          学会辨别善意，主动结交品德高尚的朋友，让你的人际关系更纯粹、更有价值。
          建立高质量社交圈，远离消耗型关系，收获真诚友谊。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/ren-shan-jiao-li-nian"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-white rounded-full text-sm font-medium hover:bg-accent-600 cursor-pointer transition-all duration-300 whitespace-nowrap"
          >
            探索人善交理念
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/25 cursor-pointer transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}